// Error messages that are used (or could be) in multiple places
export var badArguments = 'Bad arguments';
export var noRegistryFunctionReturn = 'A function was specified for "%s" %s, but no %s was returned';
export var missingPlugin = function ( name, type ) { return ("Missing \"" + name + "\" " + type + " plugin. You may need to download a plugin via http://docs.ractivejs.org/latest/plugins#" + type + "s"); };

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/config/errors.js.map
